import { useState } from 'react'
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

const CopyToClipboardButton = ({
  copyText,
  copiedMessage = null,
  defaultMessage
}) => {
  const { t } = useTranslation()
  const [linkCopied, setLinkCopied] = useState(false)

  const copyLink = () => {
    navigator.clipboard.writeText(copyText)
    setLinkCopied(true)
    setTimeout(() => {
      setLinkCopied(false)
    }, 3000)
  }

  return (
    <>
      {copyText && (
        <Button
          variant='outlined'
          size='small'
          color='primary'
          startIcon={
            !copiedMessage && <LinkOutlinedIcon sx={{ fontSize: 20 }} />
          }
          onClick={copyLink}>
          {linkCopied ? (
            copiedMessage ?? t('fullReport.linkCopied')
          ) : (
            <>{defaultMessage ?? t('fullReport.copyLink')}</>
          )}
        </Button>
      )}
    </>
  )
}

export default CopyToClipboardButton
